import React, { useDispatch, useSelector } from 'react-redux';
import { compose } from 'redux';
import withBoostrapApp from '../../components/HOC/withBoostrapApp';
import withSidebar from '../../components/HOC/withSidebar';
import withLockedView from '../../components/HOC/withLockedView';
import BusinessState from '../../features/business/BusinessState';
import { BUSINESS_READY } from '../../features/business/businessStatus';
import DateRangeFilter from '../../features/filters/DateRangeFilter';
import OperatorFilter from '../../features/filters/OperatorFilter';
import WalletState from '../../features/wallets/WalletState';
import { WALLETS_READY } from '../../features/wallets/walletStatus';
import { isEmpty } from '../../utils/stringHelper';
import { useEffect } from 'react';
import FirestoreReports from '../../api/firebase/firestore.reports';
import {
  reportsSetAll,
  reportsStatus,
} from '../../features/reports/reportsSlice';
import { LOADED } from '../../constant/variables';
import ReportItemCollections from '../../features/reports/ReportItemCollections';
import ReportStatsCollections from '../../features/reports/ReportStatsCollections';
import Svg from '../../assets/svg';
import { useNavigate } from 'react-router-dom';
import { PROTECTED_VIEWS_LOCK } from '../../router/routeNames';

const Reports = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const wallet = useSelector((state) => state.wallet);
  const business = useSelector((state) => state.businesses);
  const filters = useSelector((state) => state.filters);

  const loadReports = async () => {
    // Load reports here
    const userId = user?.data?.uid;

    const reportsCollections = await FirestoreReports.LoadByFilterAndBusinessId(
      filters,
      userId
    );
    if (reportsCollections !== null && reportsCollections.length >= 0) {
      // Process reports data as needed
      dispatch(reportsSetAll(reportsCollections));
    } else {
      // Handle error or empty state
      dispatch(reportsSetAll([]));
    }
    dispatch(reportsStatus(LOADED));
  };

  useEffect(() => {
    loadReports();
  }, [filters, user]);

  if (business.status === BUSINESS_READY && business?.ids.length === 0) {
    return <BusinessState />;
  }

  if (
    wallet.status === WALLETS_READY &&
    isEmpty(wallet?.data?.paymentMethodId)
  ) {
    return (
      <WalletState
        title="Add Payment Method"
        description="First time here! Setup Payment Method to sent credit to your loves ones."
      />
    );
  }
  const handleLockScreen = () => {
    navigate(`${PROTECTED_VIEWS_LOCK}${location.pathname}`);
  };
  const renderLockButton = () => {
    return (
      <div
        onClick={handleLockScreen}
        className="w-[135px] h-[48px] bg-[#4343d6] rounded-[10px] flex items-center justify-center gap-2 px-3 hover:bg-[#3333b3]"
      >
        <img src={Svg.payment_lock} alt="Lock Icon" className="w-5 h-5" />
        <span className="text-white text-xs font-bold leading-none tracking-tight">
          Lock Screen
        </span>
      </div>
    );
  };

  return (
    <div>
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            Reports
          </h2>
        </div>
        <div className="mt-4 flex md:mt-0">
          {renderLockButton()}
          <OperatorFilter />
          <DateRangeFilter />
        </div>
      </div>
      <ReportStatsCollections />
      <ReportItemCollections />
    </div>
  );
};

export default compose(withBoostrapApp, withSidebar, withLockedView)(Reports);
